import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
const StoreBreadcrumb = (props) => {
    const { t } = useTranslation();
    const { store, currentCity, currentCountry, inStoreLocator, hideStoreName } = props;
    const { baseUrl } = useSelector((state) => state.storelocator);
    return (React.createElement("nav", { "aria-label": t('navigation.breadcrumb.aria'), className: "breadcrumb" },
        React.createElement("ol", null,
            React.createElement("li", null,
                React.createElement("a", { href: `${baseUrl}/storelocator` }, t('storelocator.label'))),
            React.createElement("li", null,
                React.createElement("a", { href: `${baseUrl}/storelocator/${store.slugcountry}`, "aria-current": currentCountry && !currentCity ? 'page' : undefined }, store.countryCode.displayValue)),
            (!inStoreLocator || currentCity) && (React.createElement("li", null,
                React.createElement("a", { href: `${baseUrl}/storelocator/${store.slugcity}`, "aria-current": currentCity ? 'page' : undefined }, store.city))),
            !inStoreLocator && !hideStoreName && (React.createElement("li", null,
                React.createElement("a", { href: `${baseUrl}/storelocator/${store.slug}`, "aria-current": "page" }, store.name))))));
};
export default StoreBreadcrumb;
